var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4162 7.41619H8.58381V1.58381C8.58381 1.26343 8.32181 1 8 1C7.67962 1 7.41619 1.262 7.41619 1.58381V7.41619H1.58381C1.26343 7.41619 1 7.67819 1 8C1 8.32038 1.262 8.58381 1.58381 8.58381H7.41619V14.4162C7.41619 14.7366 7.67819 15 8 15C8.32038 15 8.58381 14.738 8.58381 14.4162V8.58381H14.4162C14.7366 8.58381 15 8.32181 15 8C14.9986 7.67962 14.7366 7.41619 14.4162 7.41619Z",
    fill: "#11788f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGreen);
export default __webpack_public_path__ + "static/media/add-green.40bd43c06cc127f2d21f2aaa714f68c4.svg";
export { ForwardRef as ReactComponent };